import { Component, OnInit, OnDestroy, EventEmitter, ViewChild, AfterContentInit } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { LayerSelectionDialogService } from '../layer-selection-dialog.service.';
import { LayerSelectionDialogComponent, ILayerSelectDialogConfig } from '../layer-selection-dialog.component';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { ILayerViewLayer, LayerViewsService } from 'src/app/model/api-services/layer-views.service';
import { DictHandler } from 'src/app/types/@types/sl-v-types';
import { LayerListProviderService, ILayerViewLayerNode } from 'src/app/services/layer-list-provider.service';
import { TreeComponent, TreeModel, ITreeOptions } from '@circlon/angular-tree-component';
import { Subject } from 'rxjs';
import { ResultMoment, ResultSetSrc, ResultsService } from 'src/app/services/results.service';
import { Synchable, SynchEvent } from 'src/app/model/synchronizer';
import { TreeOptions } from '@circlon/angular-tree-component/lib/models/tree-options.model';
import { ITreeNode } from '@circlon/angular-tree-component/lib/defs/api';


@Component({
	selector: 'app-modal-layer-selection',
	templateUrl: './modal-layer-selection.component.html',
	styleUrls: ['./modal-layer-selection.component.scss']
})
export class ModalLayerSelectionComponent implements OnDestroy, OnInit {
	public actions: EventEmitter<any> = new EventEmitter();

	public viewsReady = false;
	public layersReady = false;
	public modalRef: NgbModalRef;
	private subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
	private synchProxy: Synchable;
	public treeOptions: ITreeOptions = {
		allowDrag: false,
		isExpandedField: 'expanded'
	};
	public layers: Array<any> = [
		{
			name: 'layers',
			expanded: true,
			children: []
		}
	];
	public get currentSelections(): any {
		const layers: Array<ILayerViewLayerNode> = this.tree.nodes[0].children;

		const currentSelections = {};
		for (const item of layers) {
			currentSelections[item.layer.id] = item.isSelected;
		}
		return currentSelections;
	}
	public lastTitle: string | null = null;
	private map: ISLMap = null;
	private layerSet: Array<ILayerViewLayer | ResultSetSrc>;
	private handler: DictHandler;
	public selections: any;
	private moment: ResultMoment;

	@ViewChild(TreeComponent)
	private tree: TreeComponent;


	constructor(private layerViews: LayerViewsService,
		private layerLists: LayerListProviderService,
		private resultsSvc: ResultsService) {
	}
	ngOnDestroy() {

	}
	ngOnInit() {
		this.synchProxy = {
			channel: null,
			synchId: 'results-gallery-layers',
			synchables: [],
			handler: (event: SynchEvent) => {

			}
		};
		this.resultsSvc.AddSynchable(this.synchProxy);

	}

	HandleNodeExpander(node: any, event: any) {

	}
	IsHeading(node, index) {
		return node.data === this.layers[0];
	}
	Show(info: ILayerSelectDialogConfig) {
		this.moment = info.moment;
		if (!!info.moment) {
			if (!!this.moment.resultSet.displayedLayers) {
				info.selections = this.moment.resultSet.displayedLayers;
			}
		}
		if (info.selections === undefined) {
			info.selections = [];
		}
		if (!!info.map) {
			this.map = info.map;
		}
		if (!!info.layers) {
			this.layersReady = false;
			this.layerSet = info.layers;
		}
		if (!this.layerSet) {
			this.layerSet = [];
		}
		this.selections = info.selections;
		switch (info.mode) {
			case 'from-map':
				this.layersReady = false;
				this.layers[0].children = this.layerLists.GetTreeViewFromViewLayers(
					this.map.layers as Array<ILayerViewLayer>, info.selectDefault, info.selections
				);
				this.LayersReady();
				break;
			case 'gallery':
			case 'from-set':
				this.layersReady = false;
				this.layers[0].children = this.layerLists.GetTreeViewFromViewLayers(
					this.layerSet as Array<ILayerViewLayer>, info.selectDefault, info.selections);
				this.LayersReady();
				break;
			case 'from-views':
				break;
		}
		this.handler = info.handler;
		
	}
	LayersReady() {
		window.requestAnimationFrame(() => {
			this.layersReady = true;
		});
	}
	NotifyListeners() {
		if (!!this.moment) {
			this.moment.resultSet.displayedLayers = this.currentSelections;
		}
		this.handler({ selections: this.currentSelections, moment: this.moment });

	}
	MergeMoment(): ResultMoment | null {
		if (!!this.moment) {
			this.moment.resultSet.displayedLayers = this.selections;

			let layerCount = 0;
			let featureCount = 0;
			for (const item of this.moment.resultSet.results) {
				if (this.moment.resultSet.displayedLayers['' + item.layer]) {
					layerCount += 1;
					featureCount += item.features.length;
				}

			}
			this.moment.resultSet.displayedLayerCount = layerCount;
			this.moment.resultSet.displayedFeatureCount = featureCount;
			this.resultsSvc.Synch(
				{
					channel: this.moment.id,
					data: this.moment,
					source: 'result-gallery-layers',
					topic: 'displayed-layers-update'
				}
			);
			return this.moment;

		}
		return null;
	}

	HandleTreeChange() {

	}
	HandleTreeToggle() {

	}
	HandleLayerChange(node, $event) {
		this.selections['' + node.data.layer.id] = ($event.target as HTMLInputElement).checked;
	}
	ToggleVis(node, event) {
		alert('hi');
	}
	TreeReady() {

	}

}
